import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from 'antd';
import { SectionCard, StatusTag, useFlatPage } from '../components/ui';
import notify from "../utils/notify";

const KYCVerificationPage = () => {
  useFlatPage();
  const { authData } = useAuth();
  const { isKycCompleted, trialTime } = authData;
  const navigate = useNavigate();

  // Handle redirection based on KYC and trial status
  useEffect(() => {
    if (authData && isKycCompleted === true && trialTime > 0) {
      //console.log('User has active trial and KYC completed. Redirecting to dashboard...');
      navigate('/dashboard');
    }

    if (authData && isKycCompleted === true && trialTime === 0) {
      //console.log('Test KYCVerificationPage');
      //navigate('/setup-hotel');
    }
  }, [authData, isKycCompleted, trialTime, navigate]);

  // Debugging log to check if the page is loading
  useEffect(() => {
    //console.log('KYCVerificationPage loaded');
    //console.log('KYC Status:', isKycCompleted);
  }, [isKycCompleted]);

  const handleResubmit = () => {
    notify.info('Redirecting to KYC Upload page...');
  };

  const approved = isKycCompleted === 2;
  const rejected = isKycCompleted === 3;

  const info = approved
    ? { chip: 'available', label: 'Approved', title: 'KYC approved', text: 'Your KYC has been successfully verified.' }
    : rejected
    ? { chip: 'cancelled', label: 'Rejected', title: 'KYC rejected', text: 'Your KYC submission was rejected. Please resubmit your documents.' }
    : { chip: 'pending', label: 'Pending review', title: 'Verification pending', text: 'Your verification is under review. Please wait for approval.' };

  return (
    <div className="hms-page">
      <SectionCard title="Owner verification">
        <div className="hms-summary">
          <div>
            <div className="hms-summary-title">{info.title}</div>
            <div className="hms-summary-sub">{info.text}</div>
          </div>
          <StatusTag status={info.chip}>{info.label}</StatusTag>
        </div>

        {!approved && (
          <div className="hms-form-actions" style={{ justifyContent: 'flex-start', marginTop: 16 }}>
            <Button
              type="primary"
              onClick={() => {
                if (rejected) handleResubmit();
                navigate('/kyc-upload');
              }}
            >
              {rejected ? 'Resubmit documents' : 'Upload your documents'}
            </Button>
          </div>
        )}
      </SectionCard>
    </div>
  );
};

export default KYCVerificationPage;
